import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'hourBand',
})
export class HourBandPipe implements PipeTransform {
  constructor() {}

  transform(hour: number, hourIsEndOfBand: boolean = false): string {
    if (hour == null || typeof hour == 'undefined') {
      ('');
    }

    const startOfBand = hourIsEndOfBand ? hour - 1 : hour;

    return (
      `${startOfBand}:00`.padStart(5, '0') + ' - ' + `${(startOfBand + 1) % 24}:00`.padStart(5, '0')
    );
  }
}
